(() => {
  if (window.ninjaDeliveryEstimate) {
    window.ninjaDeliveryEstimate(document);
    return;
  }
  const holidays = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    const easter = new Date(Date.UTC(year, month - 1, day, 12));
    const dates = new Set(['01-01', '05-01', '10-03', '12-25', '12-26']);
    [-2, 1, 39, 50].forEach((offset) => {
      const date = new Date(easter);
      date.setUTCDate(date.getUTCDate() + offset);
      dates.add(date.toISOString().slice(5, 10));
    });
    return dates;
  };
  const calendar = new Map();
  const isWorkday = (date) => {
    const year = date.getUTCFullYear();
    if (!calendar.has(year)) calendar.set(year, holidays(year));
    return ![0, 6].includes(date.getUTCDay()) && !calendar.get(year).has(date.toISOString().slice(5, 10));
  };
  const advance = (date, days, business) => {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (!business || isWorkday(result)) added += 1;
    }
    return result;
  };
  const update = (root) => {
    const estimates = root.matches?.('[data-delivery-estimate]')
      ? [root]
      : root.querySelectorAll('[data-delivery-estimate]');
    estimates.forEach((element) => {
      element.hidden = true;
      const config = element.dataset;
      const countries = (config.countries || '').split(',').map((country) => country.trim().toUpperCase());
      if (!/^[A-Z]{2}$/.test(config.origin || '') || (!countries.includes('*') && !countries.includes(config.country))) return;
      const min = Number(config.minDays);
      const max = Number(config.maxDays);
      if (!Number.isInteger(min) || !Number.isInteger(max) || min < 0 || max < min || max > 60) return;
      if (!['business', 'calendar'].includes(config.dayType) || !config.timezone) return;
      try {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: config.timezone === 'local' ? Intl.DateTimeFormat().resolvedOptions().timeZone : config.timezone,
          year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date());
        const dateParts = Object.fromEntries(parts.map((part) => [part.type, part.value]));
        const start = new Date(Date.UTC(Number(dateParts.year), Number(dateParts.month) - 1, Number(dateParts.day), 12));
        const business = config.dayType === 'business';
        const earliest = advance(start, min, business);
        const latest = advance(start, max, business);
        const formatter = new Intl.DateTimeFormat('de-DE', {
          timeZone: 'UTC', weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric'
        });
        const output = element.querySelector('[data-delivery-dates]');
        if (!output) return;
        output.textContent = min === max
          ? formatter.format(earliest)
          : `${formatter.format(earliest)} – ${formatter.format(latest)}`;
        element.hidden = false;
      } catch {
        element.hidden = true;
      }
    });
  };
  window.ninjaDeliveryEstimate = update;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => update(document), { once: true });
  else update(document);
  document.addEventListener('shopify:section:load', (event) => update(event.target));
  window.addEventListener('pageshow', () => update(document));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) update(document);
  });
  setInterval(() => update(document), 60000);
})();
